module.exports = __webpack_public_path__ + "media/images/tourimage-2a17f286.png";